export default __webpack_public_path__ + "static/media/watercolor.eb2032b2.jpg";